import { Col, Row, Skeleton } from 'ui';

const EventsListGroupSkeleton = () => (
  <>
    {['event-1', 'event-2', 'event-3'].map((id) => (
      <Row gutter="xl" key={id}>
        <Col span={4}>
          <Skeleton active paragraph={{ rows: 2 }} title={false} />
        </Col>
        <Col span={16}>
          <Skeleton active paragraph={{ rows: 2 }} title={false} />
        </Col>
        <Col span={4}>
          <Skeleton active paragraph={{ rows: 2 }} title={false} />
        </Col>
      </Row>
    ))}
  </>
);

export default EventsListGroupSkeleton;
